import { LOGIN_REQUIRED_PAGES } from '@/utils/constants';
import { useSelector } from 'react-redux';

const BFF_DOWN_STATUS_CODE = 501;
const UNAUTHORIZED_STATUS_CODE = 401;

const ErrorService = (navigateFn, location, logout) => {
  const errors = [useSelector(state => state.auth.error)];

  const error = errors.find(error => error.hasError);

  return error ? hasErrors(error, navigateFn, location, logout) : { hasError: false };
};

const hasErrors = (error, navigateFn, location, logout) => {
  const { state, code } = error;
  if (state === 'auth' || code === UNAUTHORIZED_STATUS_CODE) {
    const path = location.pathname.split('/')?.[1];
    if (LOGIN_REQUIRED_PAGES.includes(path)) {
      logout();
      navigateFn('/login');
    }
    return { hasError: false };
  }

  return { hasError: true, ...error };
};

export const handleError = error => {
  console.log(error);
  const { response } = error;
  if (response) {
    const { status, data } = response;
    const message = data?.message ?? 'An error occurred';
    const type    = data?.error?.message ?? data?.error ?? String(status);
    throw { status, message, type };
  } else {
    const { code: type, message } = error;
    throw { status: BFF_DOWN_STATUS_CODE, message, type };
  }
};

export default ErrorService;
